export const isMultilineText = (element: HTMLElement) => {
  const range = document.createRange()
  range.selectNodeContents(element)
  const rects = range.getClientRects()
  const rectArray = Array.from(rects ?? []).filter(
    clientRect => clientRect.width !== 0 || clientRect.height !== 0
  )
  return rectArray.length > 1
}
